import React from 'react';





const SearchearIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.5566 28.1673L25.3254 21.936C25.0441 21.6548 24.6629 21.4985 24.2629 21.4985H23.2441C24.9691 19.2923 25.9941 16.5173 25.9941 13.4985C25.9941 6.31729 20.1754 0.498535 12.9941 0.498535C5.81289 0.498535 -0.00585938 6.31729 -0.00585938 13.4985C-0.00585938 20.6798 5.81289 26.4985 12.9941 26.4985C16.0129 26.4985 18.7879 25.4735 20.9941 23.7485V24.7673C20.9941 25.1673 21.1504 25.5485 21.4316 25.8298L27.6629 32.061C28.2504 32.6485 29.2004 32.6485 29.7816 32.061L31.5504 30.2923C32.1379 29.7048 32.1379 28.7548 31.5566 28.1673ZM12.9941 21.4985C8.57539 21.4985 4.99414 17.9235 4.99414 13.4985C4.99414 9.07979 8.56914 5.49854 12.9941 5.49854C17.4129 5.49854 20.9941 9.07353 20.9941 13.4985C20.9941 17.9173 17.4191 21.4985 12.9941 21.4985Z"
        fill={'currentColor'}
      />
    </svg>
  );
};

export default SearchearIcon;
